/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssetManagementItem } from '../../models/asset-management-item';
import { BaseResponse } from '../../models/base-response';
import { ReplacemeentOfTheReplacementUpdateDto } from '../../models/replacemeent-of-the-replacement-update-dto';

export interface AssetManagementControllerReplacementOfTheReplacement$Params {
      body: ReplacemeentOfTheReplacementUpdateDto
}

export function assetManagementControllerReplacementOfTheReplacement(http: HttpClient, rootUrl: string, params: AssetManagementControllerReplacementOfTheReplacement$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AssetManagementItem;
}>> {
  const rb = new RequestBuilder(rootUrl, assetManagementControllerReplacementOfTheReplacement.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AssetManagementItem;
      }>;
    })
  );
}

assetManagementControllerReplacementOfTheReplacement.PATH = '/asset-management/replacement-of-the-replacement';
